<template>
  <div>
    <set-guest-master />
    <set-guest-off v-if="!on" />
    <template v-else>
      <div class="ss-g" :class="ctl.isPhone ? 'ss-g1' : 'ss-g2 ss-g2--eq'">
        <div class="ss-gm">
          <set-card id="vrijeme" :title="$t('delivery_time_set')" :desc="$t('settings_shell.delivery.time_d')">
            <div class="ss-frow-g">
              <set-time path="delivery_from" :label="$t('from')" :aria="$t('settings_shell.delivery.from_aria')" />
              <set-time path="delivery_to" :label="$t('to')" :aria="$t('settings_shell.delivery.to_aria')" />
            </div>
            <set-switch path="check_delivery_time" :title="$t('settings_shell.delivery.customer_sets')" :desc="$t('customer_can_set_delivery_time')" />
          </set-card>
        </div>
        <div class="ss-gm">
          <set-card id="limiti" :title="$t('settings_shell.delivery.limits')">
            <div class="ss-frow-g">
              <set-stepper path="guest.dani_bez_menija" :label="$t('settings_shell.delivery.ahead')" :min="0" :max="15" :unit="$t('settings_shell.dl.days_unit')" />
              <set-stepper path="guest.guest_cancel_order_time" :label="$t('cancel_time')" :min="0" :max="1440" :unit="$t('minutes')" />
            </div>
            <p class="ss-hint ss-hint--b">{{ $t("settings_shell.delivery.ahead_d") }}</p>
          </set-card>
        </div>
      </div>
      <set-card id="gdani" :title="$t('settings_shell.delivery.days_title')" :desc="guestDays ? $t('settings_shell.delivery.days_d') : ''">
        <template #right>
          <ui-switch tone="accent"
            :class="{ 'is-changed': ctl.changed('guest_day.new_time_changes') }" :value="Boolean(guestDays)" :label="$t('settings_shell.delivery.days_title')" @input="ctl.toggle('guest_day.new_time_changes')" />
        </template>
        <set-day-rows v-if="guestDays" kind="guest_day" />
        <p v-else class="ss-hint">{{ $t("settings_shell.delivery.days_off") }}</p>
      </set-card>
    </template>
  </div>
</template>

<script>
import SetCard from "../parts/SetCard.vue";
import SetSwitch from "../parts/SetSwitch.vue";
import SetTime from "../parts/SetTime.vue";
import SetStepper from "../parts/SetStepper.vue";
import SetDayRows from "../parts/SetDayRows.vue";
import SetGuestMaster from "../parts/SetGuestMaster.vue";
import SetGuestOff from "../parts/SetGuestOff.vue";

/** Gosti › Dostava i rokovi: vrijeme dostave, ograničenja narudžbe i rokovi po danima. */
export default {
  name: "ScreenDelivery",
  components: { SetCard, SetSwitch, SetTime, SetStepper, SetDayRows, SetGuestMaster, SetGuestOff },
  inject: { ctl: "settingsCtl" },
  computed: {
    on() {
      return Boolean(this.ctl.val("lice_bez_ugovora"));
    },
    guestDays() {
      return Boolean(this.ctl.val("guest_day.new_time_changes"));
    },
  },
};
</script>
